module.exports = __webpack_public_path__ + "fonts/AudiType-Bold_4.03.b2f66097.woff";